import styled from "styled-components";
import TitleBackgroundPNG from './assets/title.png'


export const ContentCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: 3px;
    border: 2px solid rgba(95, 112, 150, 0.3);
   // background-color: rgba(20, 26, 39, 0.5);
    margin: 10px;
    box-sizing: border-box;
    background-image: url(${TitleBackgroundPNG});
    background-repeat: no-repeat;
    background-position: left top; 
    background-size: 100% 38px; 
    position: relative; /* 使伪元素定位基于此容器 */
    overflow: visible;

    /* &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
        border-top: 3px solid rgb(23,108,180);
        border-left: 3px solid rgb(23,108,180);
        pointer-events: none;
    }

    &::after {
        content: '';
        position: absolute;
        top: -2px;
        right: -2px;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
        border-top: 3px solid rgb(23,108,180);
        border-right: 3px solid rgb(23,108,180);
        pointer-events: none;
    } */
`;

export const Title = styled.div`
    color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    box-sizing: border-box;
    display: flex; 
    flex-direction: row;
    align-items: flex-end;
`;


export const TitleCn = styled.div`
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 4px;
`;

export const TitleEn = styled.div`
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 2px;
`;

export const TitleSeparator = styled.div`
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 0px 10px ;
`;

export const TitleBorder = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
`;

export const BorderLeftCircle = styled.div`
    width: 3px;
    height: 3px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0px 5px 0px 0px;
`;

export const BorderLeftBlock = styled.div`
    height: 3px;
    width: 30px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const BorderLine = styled.div`
    flex: 1 1 auto;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const BorderRightBlock = styled.div`
    height: 3px;
    width: 30px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const Content = styled.div`
    flex: 1 1 auto;
    position: relative; /* 用于绘制底部两个角的伪元素 */

    /* &::before {
        content: '';
        position: absolute;
        bottom: -2px;
        left: -2px;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
        border-bottom: 3px solid rgb(23,108,180);
        border-left: 3px solid rgb(23,108,180);
        pointer-events: none;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
        border-bottom: 3px solid rgb(23,108,180);
        border-right: 3px solid rgb(23,108,180);
        pointer-events: none;
    } */
`;

